import {
  schema,
} from 'normalizr';

// tenant schema
export const tenantSchema = new schema.Entity('clients');

export default {
  tenantSchema,
};
